import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ISeatInfo } from "@/domain/entities/book";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SeatsLayout',
  props: {
  selectable: {
    type: Boolean,
    default: false,
  },
  currentFloor: {
    type: Number,
    required: true,
  },
  totalFloor: {
    type: Number,
    required: true,
  },
  seatsInfo: {
    type: Array as PropType<Array<ISeatInfo | undefined>>,
    required: true,
  },
  numberOfRows: {
    type: Number,
    required: true,
  },
  numberOfColumns: {
    type: Number,
    required: true,
  },
  mySeatNo: {
    type: String,
  },
  duplicateSeatNo: {
    type: String,
  },
},
  emits: ["onClickSeat"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "d6fe86bc-numberOfColumns": (__props.numberOfColumns),
  "d6fe86bc-numberOfRows": (__props.numberOfRows)
}))

const props = __props;

const emit = __emit;

// const alphabetCodes = Array.from(Array(props.numberOfRows)).map(
//   (_, i) => i + 65
// );
// const seatRowLabels = alphabetCodes
//   .map((alphabetCode) => String.fromCharCode(alphabetCode))
//   .reverse();

const isSelectedSeat = (seatInfo: ISeatInfo | undefined) => {
  /**
   * 2층 버스라도 좌석 번호가 겹치지는 않는다는 가정으로 아래 조건 생략
   * seatInfo.floorNo === props.currentFloor &&
   */
  return seatInfo?.seatNo === props.mySeatNo;
};
const isSelectable = (seatInfo: ISeatInfo) => {
  return !props.selectable || !seatInfo.bookedBySomeone;
};
const onClickSeat = (seatInfo: ISeatInfo) => {
  if (!isSelectable(seatInfo)) {
    return;
  }
  emit("onClickSeat", seatInfo);
};

const __returned__ = { props, emit, isSelectedSeat, isSelectable, onClickSeat }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})